var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-badge',{attrs:{"color":_vm.color,"dot":"","value":_vm.badge}},[_vm._v(_vm._s(_vm.v))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }